// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2nptlMU4De-f1l {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 32px;\n  margin: 8px 0;\n}\n._3MoUmPWwqtD70X {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 4px;\n  min-width: 40px;\n  width: 40px;\n  height: 32px;\n  background-color: #C1C7D0;\n}\n._3lyffaOGNZ2h90 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 2px;\n  height: 16px;\n  background-color: #EBECF0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItemSkeleton": "_2nptlMU4De-f1l",
	"boardAvatarSkeleton": "_3MoUmPWwqtD70X",
	"boardNameSkeleton": "_3lyffaOGNZ2h90"
};
export default ___CSS_LOADER_EXPORT___;
